import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../../utils/cx';
import { Icon } from '../Icon/Icon';
import s from './Tag.module.css';

export type TagTone =
  | 'neutral'
  | 'accent'
  | 'highlight'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'selected'
  | 'muted';

export type TagProps = {
  tone?: TagTone;
  size?: 'sm' | 'md';
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
};

/** Small status label. Pill-shaped; hugs its text. Never interactive (use Chip for that). */
export function Tag({ tone = 'neutral', size = 'sm', icon, children, className }: TagProps) {
  return (
    <span className={cx(s.tag, className)} data-tone={tone} data-size={size}>
      {icon ? <Icon icon={icon} size="sm" /> : null}
      {children}
    </span>
  );
}
